import styled from "styled-components";

const Header = styled.div`
  font-size: 18px;
  line-height: 20px;
  margin-bottom: 20px;
`;
export default Header;
